import React, { Component } from 'react'
import { Button, Card } from 'hljd'
import isEmpty from 'lodash/isEmpty'
import EditCustomer from '../../list/addCustomer'
import { observer } from 'mobx-react'
import style from './style.module.less'

@observer
class DetailInfo extends Component {
  renderQuestion = list => {
    return list
      .map(item => {
        if (item.text) {
          const name = item.name ? `${item.name}：` : ''
          return `${name}${item.text}`.replace('其他:', '')
        } else {
          return item.name
        }
      })
      .join('， ')
  }

  render() {
    const { store, detailData = {}, id } = this.props
    const { customerVisible, supportNames } = store
    let type = []
    !!detailData.demand_list &&
      detailData.demand_list.forEach(item => {
        type.push(item.property_name)
      })
    return (
      <Card
        className={style['detail-info']}
        title="详细信息"
        extra={
          <Button
            type="primary"
            onClick={() =>
              store.setStoreData([{ type: 'customerVisible', value: true }])
            }
          >
            编辑
          </Button>
        }
      >
        <div className={style.item}>
          <span>负责人：</span>
          <span style={{ color: '#FF801A' }}>{supportNames || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>城市：</span>
          <span>
            {detailData.city_name && detailData.city_name.length
              ? detailData.city_name.join('/')
              : '未填写'}
          </span>
        </div>
        <div className={style.item}>
          <span>婚期：</span>
          <span>{detailData.weddingday || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>电话：</span>
          <span>{detailData.user_phone || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>微信号：</span>
          <span>{detailData.user_wechat || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>来源：</span>
          <span>{detailData.source_name || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>伴侣姓名：</span>
          <span>{detailData.mate_name || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>伴侣手机：</span>
          <span>{detailData.mate_phone || '未填写'}</span>
        </div>
        <div className={style.item}>
          <span>伴侣微信：</span>
          <span>{detailData.mate_wechat || '未填写'}</span>
        </div>

        {detailData.lead_intent && (
          <div className={style.item}>
            <span>初步需求：</span>
            <span>{detailData.lead_intent}</span>
          </div>
        )}

        <div className={`${style.item} ${style['mt-24']}`}>
          <span>总预算：</span>
          <span>{detailData.budget_money_sum || '未填写'}</span>
        </div>
        <div
          className={`${style.item} ${style['flex-item']} ${style['mb-24']}`}
        >
          <span>需求类型：</span>
          <span className={style['active-color']}>
            {!isEmpty(type) ? type.join('、') : '未填写'}
          </span>
        </div>

        {!!detailData.demand_list &&
          detailData.demand_list.map((item, index) => {
            return (
              <div className={style['yusuan-item']} key={index}>
                <div className="header clearfix">
                  <span>{item.property_name}</span>
                  <span className="fr">
                    预算&nbsp;&nbsp;{item.budget_money}
                  </span>
                </div>
                <div className="body">{item.remark}</div>
                <div className={style.survey}>
                  {item.survey_answer.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className={style['survey_title']}>
                          {`${index + 1}.${item.question_title.replace(
                            '（可多选）',
                            ''
                          )} ：`}
                        </div>
                        <span>{this.renderQuestion(item.answer)}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}

        <EditCustomer
          id={id}
          visible={customerVisible}
          onClose={() =>
            store.setStoreData([{ type: 'customerVisible', value: false }])
          }
          onOk={store.modifyCustomer}
          batchImport={false}
        />
      </Card>
    )
  }
}

export default DetailInfo
